import React, { useState, useEffect } from "react";
import { Form, Card, Button, Modal, Row, Col } from "react-bootstrap";
import { useGlobalState } from "../../../../services/hostelConst";
import {
  addLibraryAuthor,
  updateLibraryAuthor,
} from "../libraryServices/libraryManagement";
import {
  callToast,
  showErrorMessages,
} from "../../../../services/utilityFunctions";

const AddLibraryAuthorForm = ({ navigate, refresh }) => {
  const { closeModal, modalState } = useGlobalState();
  const masterData = modalState.data;
  const libraryId = modalState.libraryId || (masterData && masterData._LIBRARY);
  console.log("Library author modal state data:", masterData);

  const [isLoading, setIsLoading] = useState(false);
  const [showResponseModal, setShowResponseModal] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    gender: "",
    libraryId: libraryId || "",
    id: null,
  });
  const [errors, setErrors] = useState({});
  const [modalConfig, setModalConfig] = useState({
    title: "",
    message: "",
    type: "success",
  });

  const genderOptions = [
    { value: "MALE", label: "Male" },
    { value: "FEMALE", label: "Female" },
    { value: "TRANSGENDER", label: "Transgender" },
  ];

  useEffect(() => {
    if (masterData) {
      console.log("Loading author data for editing:", masterData);
      setFormData({
        firstName: masterData["FIRST NAME"] || "",
        lastName: masterData["LAST NAME"] || "",
        gender: masterData.GENDER || masterData.gender || "",
        libraryId:
          masterData._LIBRARY || masterData.libraryId || libraryId || "",
        id: masterData._ID || masterData.id || null,
      });
    }
  }, [masterData, libraryId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.firstName?.trim())
      newErrors.firstName = "First Name is required";
    if (!formData.lastName?.trim())
      newErrors.lastName = "Last Name is required";
    if (!formData.gender) newErrors.gender = "Gender is required";
    if (!formData.libraryId) newErrors.libraryId = "Library ID is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    handleConfirmedSubmit();
  };

  const handleConfirmedSubmit = async () => {
    setIsLoading(true);

    try {
      const response = formData.id
        ? await updateLibraryAuthor({
            ...formData,
            id: formData.id,
          })
        : await addLibraryAuthor(formData);

      if (response.status === "success") {
        const myButton = document.getElementById("myToastButton");
        callToast(
          "success",
          "Success",
          `Author ${formData.id ? "updated" : "added"} successfully!`,
          myButton
        );

        if (typeof refresh === "function") {
          await refresh({ columnRefresh: false, isLoading: false });
        }

        setTimeout(() => {
          closeModal();
        }, 2000);
      } else if (response.status === "fail") {
        showErrorMessages({ data: response, navigate });
        const myButton = document.getElementById("myToastButton");
        callToast(
          "error",
          "Error",
          response.message ||
            `Failed to ${formData.id ? "update" : "add"} author`,
          myButton
        );
      }
    } catch (error) {
      showErrorMessages({
        data: {
          message: `Failed to ${formData.id ? "update" : "add"} author`,
          errors: error.message,
        },
        navigate,
      });
      const myButton = document.getElementById("myToastButton");
      callToast("error", "Error", "An unexpected error occurred", myButton);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Card.Body className="px-4 py-4">
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-4">
                <Form.Label className="fw-bold">First Name</Form.Label>
                <Form.Control
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  placeholder="Enter first name"
                  isInvalid={!!errors.firstName}
                  className="shadow-sm"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.firstName}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-4">
                <Form.Label className="fw-bold">Last Name</Form.Label>
                <Form.Control
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  placeholder="Enter last name"
                  isInvalid={!!errors.lastName}
                  className="shadow-sm"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.lastName}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-4">
            <Form.Label className="fw-bold">Gender</Form.Label>
            <Form.Control
              as="select"
              name="gender"
              value={formData.gender}
              onChange={handleInputChange}
              isInvalid={!!errors.gender}
              className="shadow-sm"
            >
              <option value="">Select Gender</option>
              {genderOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Form.Control>
            <Form.Control.Feedback type="invalid">
              {errors.gender}
            </Form.Control.Feedback>
          </Form.Group>

          <div className="d-flex justify-content-end gap-2 mt-4">
            <Button variant="light" onClick={closeModal} className="px-3">
              Cancel
            </Button>
            <Button
              variant="primary"
              type="submit"
              disabled={isLoading}
              className="px-4"
            >
              {isLoading
                ? formData.id
                  ? "Updating..."
                  : "Adding..."
                : formData.id
                ? "Update Author"
                : "Add Author"}
            </Button>
          </div>
        </Form>
      </Card.Body>

      <Modal
        show={showResponseModal}
        onHide={() => setShowResponseModal(false)}
        centered
        className={`response-modal ${modalConfig.type}`}
      >
        <Modal.Body className="text-center py-4">
          <div className={`response-icon ${modalConfig.type}`}>
            {modalConfig.type === "success" ? "✓" : "✕"}
          </div>
          <h5 className="mt-3">{modalConfig.title}</h5>
          <p className="mb-0">{modalConfig.message}</p>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddLibraryAuthorForm;
